import { render } from "./Profilo.vue?vue&type=template&id=2abbc3d6&scoped=true"
import script from "./Profilo.vue?vue&type=script&lang=js"
export * from "./Profilo.vue?vue&type=script&lang=js"

import "./Profilo.vue?vue&type=style&index=0&id=2abbc3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abbc3d6"]])

export default __exports__